<section class="dashboard-funnel-section" aria-label="Lead and Applicant Funnel analytics">
  <div class="dashboard-funnel-section__cards">
    <app-dashboard-funnel-card
      title="Lead Funnel"
      entity="leads"
      [owners]="owners()"
      (analyticsLoaded)="leadAnalytics.set($event)"
    />
    <app-dashboard-funnel-card
      title="Applicant Funnel"
      entity="applicants"
      [owners]="owners()"
      (analyticsLoaded)="applicantAnalytics.set($event)"
    />
  </div>

  @if (showFunnelInsights) {
    <app-dashboard-funnel-insights
      [leadAnalytics]="leadAnalytics()"
      [applicantAnalytics]="applicantAnalytics()"
    />
  }
</section>
